import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'audit',
  async getComponent (nextState) {
    const {
      default: AuditContainer
    } = await import(/* webpackChunkName: "audit" */ './AuditContainer.tsx')
      .catch(handleChunkLoadError);
    return AuditContainer;
  },
  getData: ({ context: { props } }) => {
    return {
      ...props,
      section: 'audit'
    };
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: AuditPage
        } = await import(/* webpackChunkName: "audit" */ './AuditPage.tsx')
          .catch(handleChunkLoadError);
        return AuditPage;
      },
      getData: ({ context: { props } }) => props
    }
  ]
});
